import { configurationCookiesConfig, consoleLogAPI, setUssidToCookies } from 'src/common/functions'
import getFullCheck from 'src/apollo/queries/getFullCheck.gql'
import { CONFIG } from 'src/common/config'
import { Cookies } from 'quasar'
import sessionAuth from 'src/apollo/mutations/sessionAuth.gql'
import { TokenService } from 'src/common/token-service'
import { useSiteInfoStore } from 'src/stores/site-info'
import { useUserAuthStore } from 'src/stores/user/auth'
import { ApiServiceMain } from 'boot/api'
import { sentrySetUser } from 'src/common/sentry'
import { getRecaptchaV3Token } from 'src/services/recaptcha'

export async function authBySession(apolloClient) {
  const clearUser = () => {
    if (Cookies.has('ussidcs')) {
      ApiServiceMain.auth.removeSession()
    }
  }

  let token = Cookies.get('token')
  let ussidD = Cookies.get('ussid-d')
  let underAttack = true
  const isWebView = useSiteInfoStore().isWebView

  await apolloClient
    .query({
      query: getFullCheck,
    })
    .then(({ data }) => {
      underAttack = data.siteInfo.fullCheck
      useSiteInfoStore().updateFullCheck(data.siteInfo.fullCheck)
    })

  if (ussidD && token) {
    const configCookies = configurationCookiesConfig(token, CONFIG.COOKIES_OPTIONS)
    Cookies.remove('ussid-d', CONFIG.COOKIES_OPTIONS)
    setUssidToCookies(ussidD, configCookies.expires)
  }

  if (!token && !isWebView) {
    let session = null

    try {
      const { data } = await ApiServiceMain.auth.getSession()
      if (data?.ussidcs) {
        session = data.ussidcs
        localStorage.setItem('ussidcs-tmp', session)
      }
    } catch (e) {
      consoleLogAPI(e)
      localStorage.removeItem('ussidcs-tmp')
    }

    if (session) {
      if (!underAttack) {
        localStorage.removeItem('ussidcs-tmp')

        const captcha = await getRecaptchaV3Token('session_login')

        apolloClient
          .mutate({
            mutation: sessionAuth,
            variables: {
              session,
              captcha,
            },
          })
          .then(({ data }) => {
            const { sessionAuth } = data
            const configCookies = configurationCookiesConfig(sessionAuth.token, CONFIG.COOKIES_OPTIONS)

            const tokenService = new TokenService()
            tokenService.setToken(sessionAuth.token, sessionAuth.ussid)

            if (sessionAuth.ussid) {
              setUssidToCookies(sessionAuth.ussid, configCookies.expires)
            }

            if (sessionAuth.user?.language) {
              localStorage.setItem('u_lang', sessionAuth.user.language)
            }

            useUserAuthStore().updateToken(sessionAuth.token)
            useUserAuthStore().updateAuth(true)
            useUserAuthStore().updateUser(sessionAuth.user)
            sentrySetUser(sessionAuth.user)

            return true
          })
          .catch((e) => {
            consoleLogAPI(e)
            clearUser()
          })

        return false
      }
      return false
    }

    clearUser()
    return false
  }

  return false
}
